import { Component, Inject, ViewContainerRef  } from '@angular/core';
import { AppService } from '../../../app.service';
import { OrdinalDateAdapter, ORD_DATE_FORMATS, OrdinalDateParse } from '../adapters/ordinal-date-adapter';
import { ComponentRepairData } from '../entities/component/model';
import { GETInventoryService } from '../services/inventory.service';
import { ErrorCode, ErrorMessages } from '../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'record-replace-modal',
    templateUrl: './record-replace-modal.component.html',
    providers: [
        {
            provide: DateAdapter, useClass: OrdinalDateAdapter
        },
        {
            provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
        }
    ]
})

export class RecordReplaceModalComponent {
    ord: OrdinalDateParse = new OrdinalDateParse();

    jobsiteId: string;
    jobsiteName: string;
    componentName: string;
    cost: number;
    eventDate: Date = new Date();
    comment: string;

    minDate: Date = new Date();
    maxDate: Date = new Date();

    recordReplaceData: ComponentRepairData;
    savingChanges: boolean = false;

    // Tooltips
    ttDate: string = "Click here to select a date.";
    ttComment: string = "You may enter a maximum of 256 characters.";

    constructor(private _appService: AppService, public dialogRef: MatDialogRef<RecordReplaceModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public _inventoryService: GETInventoryService, public addRepairerWorkshopModal: MatDialog,
        public toastr: NotificationsService, vcr: ViewContainerRef) {
        
    }
    ngOnInit() {
        this.recordReplaceData = new ComponentRepairData();

        this.eventDate = new Date();
        this.recordReplaceData.date = this.eventDate;

        if (this.data != null) {

            if (this.data.jobsiteId != null) {
                this.jobsiteId = this.data.jobsiteId;

                if (this.data.jobsiteName != null) {
                    this.jobsiteName = this.data.jobsiteName;
                }
            }

            if (this.data.componentId != null) {
                this.recordReplaceData.componentId = this.data.componentId;

                if (this.data.componentName != null) {
                    this.componentName = this.data.componentName;
                }

                this._inventoryService.returnMinDateForComponentReplace(this.data.componentId)
                    .subscribe(response => {
                        if (response != "") {
                            try {
                                this.minDate = new Date(response);
                            }
                            catch (ex) {
                                this.minDate = new Date();
                            }
                        }
                    });
            }
        }
    }
    onCloseClick(): void {
        this.dialogRef.close();
    }
    saveChanges(): void {
        if (this.savingChanges) {
            return;
        }

        let validation = this.validateData();
        this.savingChanges = true;

        if (validation == ErrorCode.VALIDATION_PASSED) {
            this._inventoryService.replaceComponent(this.recordReplaceData).subscribe(response => {
                if (response == false) {
                    this.toastr.error(ErrorMessages.ERROR_SAVING);
                    this.savingChanges = false;
                }
                else {
                    this.dialogRef.close();
                }
            }, error => { console.log(error); });
        }
        else if (validation == ErrorCode.ERROR_NEGATIVE_COST) {
            this.toastr.error(ErrorMessages.ERROR_NEGATIVE_COST);
            this.savingChanges = false;
        }
        else {
            this.toastr.error(ErrorMessages.ERROR_MISSING_FIELDS);
            this.savingChanges = false;
        }
    }
    validateData(): number {
        var returnCode = ErrorCode.ERROR_MISSING_FIELDS;

        if (this.recordReplaceData.componentId
            && this.recordReplaceData.cost
            && this.recordReplaceData.date
            && this.recordReplaceData.comment) {
            if (this.recordReplaceData.cost < 0) {
                returnCode = ErrorCode.ERROR_NEGATIVE_COST;
            }
            else {
                returnCode = ErrorCode.VALIDATION_PASSED;
            }
        }

        return returnCode;
    }

    // Cost
    costChanged(): void {
        this.recordReplaceData.cost = this.cost;
    }

    // Date
    dateChanged(): void {
        this.recordReplaceData.date = this.eventDate;
        this.ord.formatDateOrdinal((this.eventDate.toString())
            .split(' ')
            .slice(1)
            .join(' '), false);
    }

    // Comment
    commentChanged(): void {
        this.recordReplaceData.comment = this.comment;
    }
}
